// extracted by mini-css-extract-plugin
export default {"link":"BackLink_link__3bof-","wrapper":"BackLink_wrapper__h4y-c","logo":"BackLink_logo__Esv2k"};